export default __webpack_public_path__ + "static/media/migrate.abd3827c.svg";